import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import DF from 'DisplayFramework';
import {
  Badge,
  Card,
  Col,
  Form,
  Input,
  Modal,
  Popover,
  Row,
  Spin,
  Steps,
  Typography,
  notification,
  List,
  Tabs,
  message,
} from 'antd';
import { useForm } from 'antd/lib/form/Form';
import UtinaCard from 'components/UtinaCard';
import Button from 'components/Button';
import Title from 'components/Title';
import { getProcTaskInit, getTaskStepEntity } from 'services/workflow';
import { useQuery } from 'react-query';
import { request } from 'utils/request';
import { API_URLS } from 'utils/config';
import { assetCatalogToAsset } from 'pages/ProposalV3/PropDetail/assetCatalogToAsset';
import { isNil, sumBy } from 'lodash';
import {
  getThirdPartyAuthorizationListByTpid,
  getThirdPartyById,
  getThirdPartyRoleListByTpid,
} from 'services/thirdParty';
import getEnvValue from 'utils/getEnvValue';
import {
  AssetRVCriteria,
  AssetUseCriteria,
  FilteringCriteria,
  getOfferDetailByOfferId,
  getParAssetUseByFilters,
  getprOfferListByPrcodeAndMgid,
  prFilteringCriteria,
} from 'services/pricing';
import moment from 'moment';
import { getRounding, toCurrency, toRate } from 'utils/utils';

import {
  ExclamationCircleFilled,
  PlusOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { getMyKeywords } from 'services/parametersService';
import {
  getAssetCatalogByKeyword,
  GetAssetCatalogByKeywordParams,
  getAssetCatalogRvAmountList,
} from 'services/assetconfig';
import Cards from './catalogCard';
import { AssetCatalogModalProps } from 'components/AssetCatalogModal/AssetCatalogModal';
import { TpRoleToTp } from 'pages/ProposalV3/PropDetail/TpRoleToTp';
import Asset from './Asset';
import { ConElemPrefinStepRequest } from 'services/proposal';
import TabPane from 'antd/lib/tabs/TabPane';
import FormInput from 'components/FormInput';
import Value from 'components/Value';
import ParListSelect from 'components/ParListSelect';
import InputCurrency from 'components/InputCurrency';
import FinancialScheduleModal from 'components/FinancialScheduleModal';
import ScheduleButton from 'components/ScheduleButton';
import ModalControllerNV from 'components/ModalControllerNV';
import ButtonOperation from 'components/ButtonOperation';
import ConElemPrefinStepModal from 'pages/ProposalV3/PropDetail/components/ConElemPrefinStepModal';
import DataGrid from 'components/DataGrid';
import { dateToString } from 'utils/utils2';
import * as finEngine from 'services/finEngine';
import { offerPrefinstepToElementStep } from 'pages/ProposalV3/PropDetail/offerPrefinstepToPrefinElementStep';
import { offerToElement } from 'pages/ProposalV3/PropDetail/offerToElement';
import NewButton from 'components/NewButton';
import { useModalState } from 'hooks/useModalState';
import SimpleAssetModal, {
  SimpleAssetModalProps,
} from 'pages/ProposalV3/PropDetail/SimpleAssetModal';

const { confirm } = Modal;
const { Text } = Typography;
const { Step } = Steps;

const NewCarFin = (props: any) => {
  const [form] = useForm();
  const [open, setOpen] = useState(0);

  const [task, setTask] = useState<any>();
  let [offer, setOffer] = useState<any>(null);
  const [tpAuth, setTpAuth] = useState<any>();
  const [requestToSend, setRequestToSend] = useState<any>(null);
  const [hover, setHover] = useState(false);
  const [prefinmethod, setPrefinmethod] = useState('');

  const [loading, setLoading] = useState<any>(false);
  const [listAsset, setListAsset] = useState<any[]>([]);
  const [count, setCount] = useState(0);
  const [finElement, setFinElement] = useState<any>();

  const [tpAuthDetail, settpAuthDetail] = useState<any>(null);

  const [processTerminated, setProcessTerminated] = useState<any>(false);

  const [requestedamount, setRequestedamount] = useState<number>();
  const [currentStep, setCurrentStep] = useState<number>(0);

  let Params: GetAssetCatalogByKeywordParams = {
    filters: '',
    keyword: '',
    mcid: 0,
    mgid: 0,
    networkcode: '',
    tpidbroker: 0,
    currcode: localStorage.getItem('currcode') ?? '',
    flagwebshop: false,
  };

  const [keyword, setkeyword] = useState('');
  const [networkcode, setNetworkcode] = useState('');

  const [assetkeyword, setAssetkeyword] = useState('');

  const {
    data: listassets,
    refetch: ref,
    isLoading,
  } = useQuery(
    ['getAssetCatalogByKeyword', keyword, Params.networkcode, networkcode],
    () =>
      getAssetCatalogByKeyword({
        filters: Params.filters,
        keyword: keyword ?? Params.keyword,
        networkcode: networkcode ?? Params.networkcode,
        //tpidbroker: Number(form.getFieldValue('broker')),
        tpidbroker: 0,
        currcode: Params.currcode,
        mcid: 0,
        mgid: Number(localStorage.getItem('mgid')),
        flagwebshop: false,
        //        offerid: !isNil(form.getFieldValue('offerid'))? Number(form.getFieldValue('offerid')) : 0,
        //      opid: !isNil(form.getFieldValue('pricing'))? form.getFieldValue('pricing')?.priid : !isNil(form.getFieldValue('opid'))  ? form.getFieldValue('opid')         : 0,
      })
        .then((response) => {
          if (response.code === '200') {
            setListAsset(response.list);
          } else {
            notification.error({
              message: response.message,
            });
            setListAsset([]);
          }
        })
        .catch((response) => {
          notification.error({
            message: response.message,
          });
          setListAsset([]);
        }),
    {
      enabled: keyword.length === 0 || keyword.length >= 3,
    }
  );

  const { data, isError } = useQuery(
    [
      'getProcTaskInit',
      {
        entity: 'THIRDPARTY',
        entityid: 0,
        funcode: 'TpAuthorizationUse' ?? '',
        action: '',
        prcode: '',
      },
    ],
    () =>
      getProcTaskInit({
        entity: 'THIRDPARTY',
        entityid: Number(localStorage.getItem('tpid')) ?? 0,
        funcode: 'TpAuthorizationUse' ?? '',
        action: '',
        prcode: '',
      }).then((result) => {
        if (result.list.length > 0) {
          setTask(result.list[0]);
          const task: any = result.list[0];
          getTaskStepEntity({
            entity: 'THIRDPARTY',
            entityid: Number(localStorage.getItem('tpid')) ?? 0,
            taskid: task.taskid ?? 0,
          }).then((res) => {
            return res.list || [];
          });
        }
      }),
    {
      staleTime: 5000,
    }
  );

  const { data: keywords, refetch: refetchkeyword } = useQuery(
    ['getMyKeywords'],
    () => getMyKeywords().then((res) => res.list),
    {
      staleTime: 1000,
    }
  );

  const simpleAssetModal = useModalState();

  const handleCreateNewAsset = () => {
    simpleAssetModal.open();
  };

  const getFilterList = (assets: any[]): prFilteringCriteria => {
    let assetList = assets ?? [];

    let assetUseCriteriaList: Array<AssetUseCriteria> = [];
    let assetRVCriteriaList: Array<AssetRVCriteria> = [];
    let offerCriteriaList: Array<FilteringCriteria> = [];
    let ret: prFilteringCriteria;

    offerCriteriaList.push({
      critcode: 'PROPORIGIN',
      critvalue: form?.getFieldValue('ctproporigin') ?? '',
    });

    offerCriteriaList.push({
      critcode: 'DEALRATING',
      critvalue: form?.getFieldValue('ctdealerrating') ?? '',
    });

    offerCriteriaList.push({
      critcode: 'OFFER',
      critvalue: form?.getFieldValue('offerid') ?? '0',
    });
    offerCriteriaList.push({
      critcode: 'NASSETS',
      critvalue: form?.getFieldValue('assets')?.length ?? '0',
    });

    const duration = form
      ?.getFieldValue(['elements', 'FIN'])
      ?.filter(
        (e: any) => e.cteid === form?.getFieldValue('selectedElement')
      )[0]?.cteduration;

    offerCriteriaList.push({
      critcode: 'DURATION',
      critvalue: duration ?? 48,
    });

    const invest = sumBy(form?.getFieldValue('assets'), 'assetnetamount');

    offerCriteriaList.push({
      critcode: 'INVEST',
      critvalue: String(invest) ?? '0',
    });

    //PROPORIGIN

    offerCriteriaList.push({
      critcode: 'PRCODE',
      critvalue: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'TPTYPE',
      critvalue: form.getFieldValue('client')?.tptype ?? '',
    });
    offerCriteriaList.push({
      critcode: 'NETWORK',
      critvalue: form.getFieldValue('ctnetworkcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'CLIRATING',
      critvalue: form.getFieldValue('client')?.tpsalestatus ?? '',
    });

    offerCriteriaList.push({
      critcode: 'ASSETCLASS',
      critvalue: 'NC' ?? '',
    });

    assetList?.forEach((a: any) => {
      assetRVCriteriaList.push({
        catalogid: a.catalogid,
        assetid: a.assetid,
        assetsegment: a.assetsegment,
        assetfamily: a.assetfamily,
        assettype: a.assettype,
        assetcategory: a.assetcategory,
        assetmodel: a.assetmodel,
        assetbrand: a.assetbrand,
        assetbrandmodel: a.assetbrandmodel,
        assetnetamount: a.assetnetamount,
        assetfinamount: a.assetfinamount,
        assetvariant: a.assetvariant,
        // assetclass :a.assetclass,
      });

      offerCriteriaList.push({
        critcode: 'ASSETFAM',
        critvalue: a.assetfamily,
      });
      offerCriteriaList.push({ critcode: 'ASSETTYPE', critvalue: a.assettype });
      offerCriteriaList.push({
        critcode: 'ASSETCAT',
        critvalue: a.assetcategory,
      });

      offerCriteriaList.push({
        critcode: 'FLAGUSED',
        critvalue: a.flagused ?? '',
      });

      offerCriteriaList.push({
        critcode: 'ASSETCLASS',
        critvalue: 'NC' ?? '',
      });

      a.power != null ??
        offerCriteriaList.push({ critcode: 'POWER', critvalue: a.power ?? '' });
      // additional attributes :
      a.entityAddAttributList?.forEach((e: any) => {
        e.attstringvalue !== null
          ? offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attstringvalue,
            })
          : e.attnumericvalue !== null ??
            offerCriteriaList.push({
              critcode: e.attcode,
              critvalue: e.attnumericvalue,
            });
      });

      if (getEnvValue('FLAG_APPLY_ASSET_USE')) {
        a.assetusereqList?.forEach((u: any) => {
          assetUseCriteriaList.push({
            assetfamily: a.assetfamily,
            assettype: a.assettype,
            assetcategory: a.assetcategory,
            catalogid: a.catalogid ?? '',
            attcode: u.attcode ?? '',
            attvalue: u.usevalue ?? '',
          });
        });
      }
    });

    ret = {
      prcode: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
      tpid: form.getFieldValue('client')?.tpid ?? 0,
      tpidbroker: form.getFieldValue('broker')?.tpid ?? 0,
      tpidmanufacturer:
        assetList && assetList.length > 0
          ? assetList![0]?.tpidmanufacturer ?? 0
          : 0,
      assetUseCriteria: assetUseCriteriaList,
      assetRVCriteria: assetRVCriteriaList,
      offerCriteria: offerCriteriaList,
      flagApplyAssetUse: getEnvValue('FLAG_APPLY_ASSET_USE'),
      flagApplyAttributesExtendDurationValues: true,
      flagApplyAttributesExtendFirstRentalValues: true,
      flagApplyAttributesExtendRVValues: true,
      flagApplyAttributesExtendRateValues: true,
      flagApplyExtendDurationValues: true,
      flagApplyExtendFirstRentalValues: true,
      flagApplyExtendRVValues: true,
      flagApplyExtendRateValues: true,
    };
    return ret;
  };

  const {
    data: ThirdPartyAuthorization,
    refetch,
    isFetching,
  } = useQuery(
    [
      'getThirdPartyAuthorizationListByTpid',
      { tpid: Number(localStorage.getItem('tpid')) },
    ],
    () =>
      getThirdPartyAuthorizationListByTpid({
        tpid: Number(localStorage.getItem('tpid')),
      }).then(async (res) => {
        if (res?.list?.length > 0) {
          form.setFieldValue('authid', res.list[0].authid);
          setTpAuth(res.list[0]);
          await getprOfferListByPrcodeAndMgid({
            filters: getFilterList([]),
          }).then((result) => {
            if (result?.list?.length > 0) {
              const filteredOffer = result.list[0];
              const filteredAuthDetailList: any[] =
                res?.list[0]?.authDetail.filter(
                  (authdetail: any) =>
                    authdetail.offerid === filteredOffer.offerid
                );
              // setTpAuthDetail(filteredAuthDetailList);

              if (filteredAuthDetailList?.length > 0) {
                const authDetail: any = filteredAuthDetailList[0];
                settpAuthDetail(authDetail);

                if (open === 0) {
                  setOpen(1);
                }
              }
            }
          });
        }
        return res.list || [];
      })
  );

  const columnsPrefinSteps = [
    {
      dataIndex: 'ctesid',
      width: 120,
      render: (val: any, record: any) => (
        <ModalControllerNV
          content={({ setVisible, visible }) => (
            <a
              onClick={() => {
                setVisible(true);
              }}
            >
              {val}
            </a>
          )}
          modal={({ setVisible, visible }) => (
            <ConElemPrefinStepModal
              visible={visible}
              onClose={() => {
                setVisible(false);
              }}
              onSave={(values, action) => {}}
              updatePreFinStep
              record={record}
            />
          )}
        ></ModalControllerNV>
      ),
    },
    {
      dataIndex: 'ctesorder',
      width: 120,
    },

    {
      dataIndex: 'ctesstartdate',
      width: 120,
    },
    {
      dataIndex: 'ctesduration',
      width: 120,
    },
    {
      dataIndex: 'ctesperiodicityunit',
      width: 120,
    },
    {
      dataIndex: 'ctesperiodicity',
      width: 120,
    },
    {
      dataIndex: 'enddate',
      width: 120,
    },
    {
      dataIndex: 'calmethod',
      width: 120,
    },
    {
      dataIndex: 'rateformula',
      width: 120,
    },
    {
      dataIndex: 'ratebasis',
      width: 120,
    },
    {
      dataIndex: 'ratespread',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'nominalrate',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'ctesstartamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
    {
      dataIndex: 'ctesinterestamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
    {
      dataIndex: 'ctesamortizedcoef',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'ctesamortizedamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
    {
      dataIndex: 'ctesrentalamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
    {
      dataIndex: 'ctesoutstandingcoef',
      width: 120,
      render: (val: number) => toRate(val),
    },
    {
      dataIndex: 'ctesoutstandingamount',
      width: 120,
      render: (val: number) => toCurrency(val),
    },
  ];

  const onChange = (value: number) => {
    if (currentStep !== 2) {
      setCurrentStep(value);
    }
  };

  const { id } = useParams<{
    id: string;
  }>();

  const getProposalId = () => {
    const idProp = id;
    if (isNil(idProp)) {
      return;
    }
    return Number(idProp);
  };

  const loadTPDetail = async (
    tpid: any,
    tpname: any,
    tpreference: any,
    tprolecode: any
  ) => {
    let tpdetail = {} as any;
    let alltp = form.getFieldValue('thirdparties') ?? [];

    let existTP = alltp.filter(
      (e: any) =>
        (typeof e.tpid === 'object' ? e.tpid.tpid : e.tpid) === tpid &&
        e.tprolecode === tprolecode
    );

    if (existTP.length === 0) {
      await getThirdPartyById({ tpid: tpid }).then(async (response) => {
        if (response.code === '200') {
          tpdetail = response.data;
        }

        await getThirdPartyRoleListByTpid({ tpid: tpid })
          .then((response) => {
            if (response.code !== '200') {
            } else {
              if (response.list?.length !== 0 && response.list !== null) {
                // api return 200 : exist role
                // delete old CLIENT :
                if (tprolecode === 'CLIENT') {
                  alltp = alltp?.filter((e: any) => e.tprolecode !== 'CLIENT');
                }

                let roleData = response.list?.find(
                  (e) => e.tprolecode === tprolecode && e.status === 'VALID'
                );

                if (roleData === null && response?.list) {
                  roleData = response?.list[0];
                }
                alltp.push(
                  TpRoleToTp(
                    tprolecode,
                    roleData,
                    tpname,
                    tpreference,
                    getProposalId()
                  )
                );

                //                  form.setFieldsValue({ thirdparties: [] });
                alltp = alltp.slice(); //thats will trigger the form
                form.setFieldsValue({
                  thirdparties: alltp,
                });
              }
            }
          })
          .catch((err) => {
            notification.error({ message: 'Error', description: err });
          });
      });
    }
  };

  const handleSelectAssetFromCatalog: AssetCatalogModalProps['onSelect'] =
    async (assetCatalog, nbasset, selectedServices, selectedOption) => {
      if (form) {
        const oldAssets = form.getFieldValue('assets') ?? [];

        const listrv = await getAssetCatalogRvAmountList({
          prcode: form?.getFieldValue('prcode') ?? '',
          catalogid: assetCatalog.catalogid,
          assetamount: assetCatalog.assetnetamount * nbasset,
          filters: getFilterList(oldAssets),
        })
          .then((res: any) => res.list)
          .catch(() => []);

        const listuse = await getParAssetUseByFilters({
          parAssetRequest: [
            {
              assetcategory: assetCatalog.assetcategory ?? '',
              assetfamily: assetCatalog.assetfamily,
              assetid: '' as any,
              assettype: assetCatalog.assettype,
              catalogid: assetCatalog.catalogid ?? '',
              offerid: '' as any,
              ofrid: '' as any,
              ofrtype: '',
              prcode: form?.getFieldValue('flagmasterfacility')
                ? form?.getFieldValue('mfprcode')
                : form?.getFieldValue('prcode') ?? '',
            },
          ],
        })
          .then((res: any) => res.list)
          .catch(() => []);

        const cteid = form.getFieldValue('selectedElement');

        let asset: any = assetCatalogToAsset(
          assetCatalog,
          listrv,
          nbasset,
          cteid,
          'catalog',
          listuse
        );

        let lassetComponents = [];

        lassetComponents = asset.assetComponents;

        if (selectedOption && selectedOption?.length > 0) {
          lassetComponents.push({
            assetid: 0,
            compcategory: 'ASSET',
            compcategorylabel: asset.assetlabel,
            compdescription: asset.assetlabel,
            compdiscountamount: 0,
            compdiscountrate: 0,
            compfree1: '',
            compgrossamount: assetCatalog.assetgrossamountorigine,
            compid: assetCatalog.catalogid,
            compnetamount: assetCatalog.assetnetamountorigine,
            comporiginalnetamount: assetCatalog.assetnetamountorigine,
            comptaxamount:
              assetCatalog.assetgrossamountorigine -
              assetCatalog.assetnetamountorigine,
            comptype: 'ASSET',
            comptypelabel: 'Asset',
            flagholdback: false,
            holdbackamount: 0,
            holdbackbeleasedate: '',
            holdbackbeleasenbdays: 0,
            holdbackpercentage: 0,
            suppliername: asset.suppliername,
            supplierreference: asset.supplierreference,
            taxcode: asset.taxcode,
            taxrate: 0,
            tpidsupplier: asset.tpidsupplier,
          });
        }

        selectedOption?.forEach((opt) => {
          lassetComponents.push({
            assetid: 0,
            compcategory: opt.optcode,
            compcategorylabel: opt.optcodelabel,
            compdescription: opt.optcodelabel + ' : ' + opt.optvaluelabel,
            compdiscountamount: 0,
            compdiscountrate: 0,
            compfree1: '',
            compgrossamount: opt.optgrossamount,
            compid: opt.optid,
            compnetamount: opt.optnetamount,
            comporiginalnetamount: opt.optnetamount,
            comptaxamount: opt.opttaxamount,
            comptype: 'OPT',
            comptypelabel: 'Option',
            flagholdback: false,
            holdbackamount: 0,
            holdbackbeleasedate: '',
            holdbackbeleasenbdays: 0,
            holdbackpercentage: 0,
            suppliername: asset.suppliername,
            supplierreference: asset.supplierreference,
            taxcode: opt.opttaxcode,
            taxrate: 0,
            tpidsupplier: asset.tpidsupplier,
          });
        });

        let newAsset = {
          ...asset,
          assetCatalogComponents: lassetComponents ?? [],
        };

        // // set element.assets :

        let newListAsset = [...oldAssets, newAsset];


        form.setFieldValue('assets', newListAsset);
        setCount(count + 1);

        let ctfinancedamount = sumBy(
          form.getFieldValue('assets'),
          'assetnetamount'
        );
        form.setFieldsValue({
          ctfinancedamount: ctfinancedamount,
          offerid: null,
          pricing: null,
          elements: [],
        });

        loadTPDetail(asset.tpidsupplier, '', '', 'SUPPLIER');

        handleOk();
        // JBR : handlePricingChange(form.getFieldValue('pricingObj'));
        //handlePricingChange(form.getFieldValue('pricing'));
      }
    };

  const displayCatalog = (keyword: string, networkcode: any) => {
    setkeyword(keyword);
  };
  const assetkeywordChange = (e: any) => {
    displayCatalog(e.target.value, form.getFieldValue('ctnetworkcode'));
  };

  const handleOk = async () => {
    // eslint-disable-next-line no-debugger
    //debugger;

    setLoading(true);

    const assets = form.getFieldValue('assets') ?? [];

    let totalAssetAmount = 0;


    assets?.forEach((asset: any) => {
      totalAssetAmount += asset.assetnetamount;
      asset.assetclass = 'NC';
    });

    setRequestedamount(totalAssetAmount);

    form.setFieldValue('assets', assets);
    const offerList = await getprOfferListByPrcodeAndMgid({
      filters: getFilterList(assets),
    }).then((res) => {
      return res.list || [];
    });

    if (offerList && offerList?.length > 0) {
      const filteredOffer = offerList[0];
      const filteredAuthDetailList: any[] = tpAuth?.authDetail.filter(
        (authdetail: any) => authdetail.offerid === filteredOffer.offerid
      );
      // setTpAuthDetail(filteredAuthDetailList);

      if (filteredAuthDetailList?.length > 0) {
        const authDetail: any = filteredAuthDetailList[0];

        form.setFieldsValue({
          event: 'tabTpAuthorizationUse',
          authdetailamount: authDetail?.authdetailamount,
          authdetailavailableamount: authDetail?.authdetailavailableamount,
          // amountToUse: e?.authdetailavailableamount,
          authdetailid: authDetail.authdetailid,
          authbookedamount: authDetail?.authbookedamount,
          authdetailusedamount: authDetail?.authdetailusedamount,
          prcodelabel: authDetail?.prcodelabel,
          prcode: authDetail?.prcode,
          offerid: authDetail?.offerid,
          offerlabel: authDetail?.offerlabel,
          ofrtype: authDetail?.ofrtype,
          ofrtypelabel: authDetail?.ofrtypelabel,
          ofridlabel: authDetail?.ofridlabel,
          ofrid: authDetail?.ofrid,
        });
        await handleOfferChange(authDetail.offerid, totalAssetAmount);
      }
    }

    if (task) {
      setRequestToSend({
        taskid: task.taskid,
        entity: 'THIRDPARTY',
        entityId: Number(localStorage.getItem('tpid')) ?? 0,
        subentity: 'AUTH',
        subentityId: 0,
        objectreference: '',
        authid: form.getFieldValue('authid'),
        authdetailid: form.getFieldValue('authdetailid'),
        tpidbeneficiairy: form.getFieldValue('tpidbeneficiairy'),
        beneficiaryname: form.getFieldValue('beneficiaryname'),
        beneficiaryreference: form.getFieldValue('authid'),
        amountToUse: totalAssetAmount ?? 0,
        prcode: form.getFieldValue('prcode'),
        offerid: form.getFieldValue('offerid'),
        ofrid: form.getFieldValue('ofrid'),
        ofrtype: form.getFieldValue('ofrtype'),
        usecomment: '',
        nominalrate: offer?.nominalrate,
        ratespread: offer?.ratespread,
        rateref: offer?.rateref,
        rateformula: form.getFieldValue('rateformula'),
        ratetype: form.getFieldValue('ratetype'),
        calculationtype: form.getFieldValue('calculationtype'),
        periodicity: '1',
        duration: form.getFieldValue('duration'),
        startDate: moment().format('YYYY-MM-DD'),
        endDate: form.getFieldValue('endDate'),
        assets: assets,
      });
    }
    setLoading(false);
    //;
  };
  const contractId = getProposalId();

  const sendRequest = () => {

    const req = {
      ...requestToSend,
      ...offer,
      prefinStepsList: form.getFieldValue('_prefinStepsList'),
      periodicity: '1',
    };
    setLoading(true);
    const [url, paramsString] = task.serviceurl
      ? task.serviceurl.split('?')
      : ''.split('?');
    // setload(true);
    request
      .post(`${API_URLS.WORKFLOW}/api/${url}`, req)
      .then((res) => {
        refetch();
        setLoading(false);
        if (res.success) {
          setCurrentStep(2);
          notification.success({ message: res.message });
        } else {
          return Promise.reject(res);
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const calculatePaymentShedulePrefinSteps = (finElement: any) => {
    let FinElemStep = form.getFieldValue('_prefinStepsList') ?? [];

    // calculate FIN
    var finamount = 0;

    const investamount = finElement.cteinvestamount;
    // const firstPayment = finElement.ctefirstpayment;
    // const rvAmount = finElement.ctervamount;
    const upfront = finElement.cteupfrontamount;

    var part = 0;

    const partmethod = finElement.ctepartmethod;

    if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
      part = isNaN(finElement.ctepartamount) ? 0 : finElement.ctepartamount;
    }

    const extracost =
      finElement.cteextracosttofinance == null
        ? 0
        : finElement.cteextracosttofinance;

    finamount = investamount + extracost - upfront - part;

    if (isNil(FinElemStep) || FinElemStep.length === 0) {
      notification.error({
        message: 'Please add steps before',
        description: '',
        duration: 10,
      });
      return;
    } else {
      FinElemStep.forEach((s: ConElemPrefinStepRequest) => {
        s.ctesoutstandingamount = (finamount * s.ctesoutstandingcoef) / 100;
      });

      setLoading(true);
      finEngine
        .calculatePaymentShedulePrefinSteps({
          finReq: {
            elementStep: form.getFieldValue('_prefinStepsList') ?? [],
            inBillingDate: finElement?.ctebilligdate,
            inCalculationMethod: 'STEP',
            inCountingbasis: finElement?.cteratebasis,
            inDeferredMethod: finElement?.ctedeferredinterestmethod,
            inDeferredRate: finElement?.ctedeferredinterestnominalrate,
            inDepositAmount:
              finElement?.ctedepositamount == null
                ? 0
                : finElement?.ctedepositamount,
            inDepositMethod: finElement?.ctedepositinterestmethod,
            inDepositRate:
              finElement?.ctedepositnominalrate == null
                ? 0
                : finElement?.ctedepositnominalrate,

            inFinancedAmount: finamount,
            inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
            inInterestMethod: finElement?.cteinterestmethod,
            inPartAmount:
              finElement?.ctepartamount == null ? 0 : finElement?.ctepartamount,
            inPartMethod: finElement?.ctepartmethod
              ? finElement?.ctepartmethod
              : 'NONE',
            inPartNbDays: form.getFieldValue('ctepartnbdays') ?? 0,
            //finElement?.ctepartdays == null ? 0 : finElement?.ctepartdays,
            inPartRate: form.getFieldValue('ctepartrate') ?? 0,
            inPartInvoicingMode:finElement?.ctepartinvoicingmode,

            //finElement?.ctepartrate == null ? 0 : finElement?.ctepartrate,
            inRatePeriodicity: finElement?.cterateperiodicity,
            inRateType: finElement?.cteratetype,
            inRateValue:
              finElement?.ctenominalrate == null
                ? 0
                : finElement?.ctenominalrate,
            inRoundingAmount: getRounding(finElement.currcode),
            inRoundingRate: 9,
            inStartDate: dateToString(finElement.ctestartdate),
            inTaxcode: finElement?.taxcode,
            inTaxrate: finElement?.taxrate,
            inTaxtype: finElement?.taxtype,
            inTerm: finElement?.ctepaymentterm,
            inUpfrontAmount: finElement?.cteupfrontamount,
          },
        })
        .then((res) => {
          setLoading(false);
          if (res.success) {
            // calculateServAndComm(res, finElement, finamount, inCteid);
            message.success(res.message);

            setFinElement({
              ...finElement,
              conElemSchedules: res.paymentSchedule,
              ctedeferredinterestnominalrate: res.inDeferredRate,
              ctedeferredinterest: res.deferredInterest,
              ctedepositnominalrate: res.inDepositRate,
              ctedepositinterest: res.depositInterest,
              cteactuarialrate: res.effectiverate,
              ctervamount: 0,
              ctervcoef: 0,
              ctefirstpayment: 0,
              ctefirstpaymentcoef: 0,
            });
          } else {
            message.error(res.message);
          }
        })
        .catch((err) => {
          setLoading(false);
        });

      /// end calculate FIN
    }
  }; // end calculate PaymentShedule Steps :

  const handleAddSimpleAsset: SimpleAssetModalProps['onAdd'] = async (
    simpleasset
  ) => {
    if (form) {
      const assets = form.getFieldValue('assets') ?? [];

      const listrv = await getAssetCatalogRvAmountList({
        prcode: form?.getFieldValue('flagmasterfacility')
          ? form?.getFieldValue('mfprcode')
          : form?.getFieldValue('prcode') ?? '',
        catalogid: simpleasset.catalogid ?? '',
        assetamount: simpleasset.assetnetamount,
        filters: getFilterList(assets),
      })
        .then((res: any) => res.list)
        .catch(() => []);

      const listuse = await getParAssetUseByFilters({
        parAssetRequest: [
          {
            assetcategory: simpleasset.assetcategory.value ?? '',
            assetfamily: simpleasset.assetfamily.value,
            assetid: '' as any,
            assettype: simpleasset.assettype.value,
            catalogid: simpleasset.catalogid ?? '',
            offerid: '' as any,
            ofrid: '' as any,
            ofrtype: '',
            prcode: form.getFieldValue('prcode'),
          },
        ],
      })
        .then((res: any) => res.list)
        .catch(() => []);

      const cteid = form.getFieldValue('selectedElement');

      const asset = assetCatalogToAsset(
        simpleasset,
        listrv,
        simpleasset.assetqty,
        cteid,
        'catalog',
        listuse
      );

      form.setFieldsValue({
        assets: [...assets, asset],
      });

      handleOk();
    }
    simpleAssetModal.close();
  };

  const handleOfferChange = (offerid: number, assetAmount: number) => {
    setLoading(true);

    getOfferDetailByOfferId({ offerid })
      .then((res) => {
        setLoading(false);

        if (res.data != null) {
          let calctype = res.data.calculationmethod;

          const new_offer = {
            ...res?.data,
            prefinnominalrate: res.data.prefinnominalrate,
            upfrontdefault: res.data.upfrontdefault,
            duration: res.data.durationdefault,
            periodicity:
              calctype === 'PREFIN'
                ? res.data.prefinperiodicity
                : res.data.periodicity,
            calculationtype: calctype,
            ratetype:
              calctype === 'PREFIN'
                ? res.data.prefinratetype
                : res.data.ratetype,
            rateformula:
              calctype === 'PREFIN'
                ? res.data.prefinrateformula
                : res.data.rateformula,
            rateref:
              calctype === 'PREFIN'
                ? res.data.prefinrateref
                : res.data.ratevaluedefault,
            ratespread:
              calctype === 'PREFIN'
                ? res.data.prefinratespreaddefault
                : res.data.ratespreaddefault,
            nominalrate:
              calctype === 'PREFIN'
                ? res.data.prefinnominalrate
                : res.data.ratespreaddefault + res.data.ratevaluedefault,
            amountToUse:
              assetAmount - (assetAmount * res.data?.upfrontdefault) / 100,
            requestAmount: assetAmount,
          };

          offer = new_offer;

          setOffer(new_offer);

          form.setFieldsValue({
            duration: res.data.durationdefault,
            periodicity:
              calctype === 'PREFIN'
                ? res.data.prefinperiodicity
                : res.data.periodicity,
            calculationtype: calctype,
            ratetype:
              calctype === 'PREFIN'
                ? res.data.prefinratetype
                : res.data.ratetype,
            rateformula:
              calctype === 'PREFIN'
                ? res.data.prefinrateformula
                : res.data.rateformula,
            rateref:
              calctype === 'PREFIN'
                ? res.data.prefinrateref
                : res.data.ratevaluedefault,
            ratespread:
              calctype === 'PREFIN'
                ? res.data.prefinratespreaddefault
                : res.data.ratespreaddefault,
            nominalrate:
              calctype === 'PREFIN'
                ? res.data.prefinnominalrate
                : res.data.ratespreaddefault + res.data.ratevaluedefault,
            amountToUse:
              assetAmount - (assetAmount * res.data?.upfrontdefault) / 100,
            requestAmount: assetAmount,
          });

          setPrefinmethod(res.data.prefinmethod);

          const _prefinStepList = res?.data?.prefinStepList ?? [];
          const finamount = form.getFieldValue('amountToUse');
          const conElemPrefinSteps = offerPrefinstepToElementStep(
            _prefinStepList,
            finamount
          );
     
          form.setFieldsValue({
            _prefinStepsList: conElemPrefinSteps,
            ctepartmethod: res.data.partmethod,
            ctepartrate: res.data.partrate,
            ctepartnbdays: res.data.partnbdays,
            ctepartnbdaysmax: res.data.partnbdaysmax,
            tpidparticipation: {
              tpid: res.data.tpidparticipation,
              tpname: res.data.tpnameparticipation,
              tpreference: res.data.tpreferenceparticipation,
            },
          });

          let Element2 = offerToElement(
            res?.data,
            finamount,
            0,
            0,
            false,
            form.getFieldValue('ctepartmethod'),
            form.getFieldValue('ctepartamount'),
            0
          );

          setFinElement(Element2);

        }
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const [clicked, setClicked] = useState(false);
  const hide = () => {
    setClicked(false);
  };
  const handleClickChange = (open: boolean) => {
    setClicked(open);
  };
  const content = (
    <Row
      style={{ width: '800px', height: '120px', padding: '15px 0px 0px 15px' }}
    >
      <Col>
        <ExclamationCircleOutlined
          style={{
            marginRight: 10,
            color: 'orange',
            fontSize: '33px',
            float: 'left',
          }}
        />
      </Col>
      <Col style={{ padding: '4px 0px' }}>
        <h3 style={{ fontWeight: 600 }}>
          {' '}
          Are you sure you want to Send this request??
        </h3>
        <span style={{ fontWeight: 600 }}>Note : </span>
        <GetLabel style={{ fontWeight: 600 }} label="text2" />
      </Col>
      <Row gutter={12} style={{ width: '100%' }} justify="end">
        <Col>
          <Button
            type="default"
            htmlType="button"
            comcode="cancel"
            onClick={() => {
              setRequestToSend(null);
              setOffer(null);
              form.resetFields();
            }}
            style={{ height: '30px', margin: '0px 10px', padding: '0px 10px' }}
          />
        </Col>
        <Col>
          <Button
            type="primary"
            htmlType="button"
            onClick={() => {
              sendRequest();
            }}
            loading={loading}
            comcode="ok"
            style={{ height: '30px', margin: '0px 10px', padding: '0px 10px' }}
          />
        </Col>
      </Row>
    </Row>
  );
  const title = (
    <>
      <ExclamationCircleFilled style={{ marginRight: 10, color: 'orange' }} />
      <GetLabel label="text1" />
    </>
  );

  return (
    <DF.Provider pagcode="newcarfin">
      <Form
        form={form}
        labelCol={{ md: 24 }}
        wrapperCol={{ md: 24 }}
        labelAlign="left"
        layout="vertical"
      >
        <Row justify="center">
          <Col span={22}>
            <Spin size="large" tip="loading ..." spinning={loading}>
              <Card style={{ paddingBottom: 35 }}>
                <Row justify="space-between">
                  <Col>
                    <Title comcode="newcarfintitle" level={2} color="#243882" />
                  </Col>
                </Row>

                <Steps
                  //labelPlacement="vertical"
                  current={currentStep}
                  onChange={onChange}
                  direction="horizontal"
                  size="default"
                  style={{ marginTop: '35px', marginBottom: '20px' }}
                  // progressDot={isNil(ctrid) ? customDot : false}
                >
                  <Step
                    stepIndex={0}
                    title={
                      <Badge count={form.getFieldValue('assets')?.length ?? 0}>
                        <li style={{ fontSize: '16px' }}>
                          {' '}
                          <GetLabel label="Asset" />{' '}
                        </li>
                      </Badge>
                    }
                    style={{ cursor: 'pointer', fontSize: '16px' }}
                    disabled={currentStep === 2}
                  />

                  <Step
                    stepIndex={1}
                    title={
                      <li>
                        {' '}
                        <GetLabel label="synthese" />{' '}
                      </li>
                    }
                    style={{ cursor: 'pointer' }}
                    disabled={currentStep === 2}
                  />
                  <Step
                    stepIndex={2}
                    title={
                      <li>
                        {' '}
                        <GetLabel label="authInfo" />{' '}
                      </li>
                    }
                    style={{ cursor: 'pointer' }}
                    disabled={currentStep !== 2}
                  />
                </Steps>

                <Row justify="start">
                  <Title comcode="newcarfintitle" level={3} color="#243882" />
                </Row>

                {currentStep === 0 ? (
                  <Col span={24}>
                    <Row>
                      <Col span={24} style={{ width: '100%', padding: '6px' }}>
                        <Row>
                          <Col
                            span={24}
                            style={{
                              padding: '25px',
                              background: ' #FFFFFF',
                              boxShadow: ' 0px 0px 7px rgba(0, 0, 0, 0.09)',
                              borderRadius: '7px',
                            }}
                          >
                            <Row gutter={16} justify="end">
                              <Col span={8}>
                                <Row gutter={8}>
                                  <Col span={14}>
                                    <Input
                                      placeholder="Enter a keyword to search"
                                      onChange={(e) => {
                                        assetkeywordChange(e);
                                      }}
                                      allowClear
                                      value={keyword}
                                      style={{ padding: 8 }}
                                    ></Input>
                                  </Col>
                                  <Col>
                                    <NewButton
                                      icon={<PlusOutlined />}
                                      type="primary"
                                      onClick={handleCreateNewAsset}
                                      style={{ width: '100%', height: 15 }}
                                      comcode="addNewAsset"
                                      height={30}
                                    />
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Spin spinning={isLoading}>
                              <List
                                style={{ marginTop: '10px' }}
                                dataSource={listAsset}
                                grid={{
                                  gutter: 16,
                                  xs: 1,
                                  sm: 1,
                                  md: 2,
                                  lg: 3,
                                  xl: 3,
                                  xxl: 3,
                                }}
                                pagination={{ pageSize: 12 }}
                                rowKey="catalogid"
                                renderItem={(e) => (
                                  <List.Item>
                                    <Cards
                                      item={e}
                                      onSelect={handleSelectAssetFromCatalog}
                                      form={form}
                                      hideServiceAndOptions
                                    />
                                  </List.Item>
                                )}
                              />
                            </Spin>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                ) : currentStep === 1 ? (
                  <>
                    {/* <div
                      style={{
                        background: '#ebebeb',
                        padding: 20,
                        marginBottom: 50,
                      }}
                    >
                      <Title level={3} comcode="req_accepet" /> */}
                    <UtinaCard comcode="req_accepet" level={4}>
                      <Row
                        style={{
                          fontSize: '16px',
                        }}
                      >
                        <Col span={8}>
                          {' '}
                          <GetLabel
                            label="requestedamount"
                            style={{ fontWeight: 'bold', color: '#243882' }}
                          />{' '}
                        </Col>{' '}
                        <Col span={12} style={{ fontWeight: 600 }}>
                          {' '}
                          {toCurrency(requestedamount)}
                        </Col>
                        <Col span={8}>
                          {' '}
                          <GetLabel
                            label="AmountFinanced"
                            style={{ fontWeight: 'bold', color: '#243882' }}
                          />{' '}
                          <span style={{ fontWeight: 'bold', color: 'red' }}>
                            ({100 - offer?.upfrontdefault}%)
                          </span>{' '}
                        </Col>{' '}
                        <Col span={12} style={{ fontWeight: 600 }}>
                          {' '}
                          {toCurrency(
                            form.getFieldValue('amountToUse'),
                            localStorage.getItem('currcode') ?? ''
                          )}
                        </Col>
                        <Col span={8}>
                          {' '}
                          <GetLabel
                            label="Interest"
                            style={{ fontWeight: 'bold', color: '#243882' }}
                          />{' '}
                        </Col>
                        <Col span={12} style={{ fontWeight: 600 }}>
                          {toRate(offer?.prefinnominalrate)}
                        </Col>
                        <Col span={8}>
                          {' '}
                          <GetLabel
                            label="ctepartrate"
                            style={{ fontWeight: 'bold', color: '#243882' }}
                          />{' '}
                        </Col>
                        <Col span={12} style={{ fontWeight: 600 }}>
                          {toRate(form.getFieldValue('ctepartrate'))}
                        </Col>
                        <Col span={8}>
                          {' '}
                          <GetLabel
                            label="ctepartnbdays"
                            style={{ fontWeight: 'bold', color: '#243882' }}
                          />{' '}
                        </Col>
                        <Col span={12} style={{ fontWeight: 600 }}>
                          {form.getFieldValue('ctepartnbdays')}
                        </Col>
                      </Row>

                      <div style={{ marginTop: 20 }}>
                        <Tabs defaultActiveKey="1" animated>
                          <TabPane tab={<GetLabel label="assets" />} key="1">
                            <Card style={{ padding: 10 }}>
                              <Form.Item shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                  const assets = getFieldValue('assets') ?? [];

                                  return (
                                    <Asset
                                      phase="PROD"
                                      form={form}
                                      reftechProp={refetch}
                                      ctrid={contractId}
                                      showActionButton={false}
                                      filtersList={getFilterList(assets)}
                                    />
                                  );
                                }}
                              </Form.Item>
                            </Card>
                          </TabPane>
                          <TabPane tab={<GetLabel label="authUse" />} key="2">
                            <Row>
                              <Col span={24}>
                                <Row gutter={30}>
                                  <UtinaCard comcode="Summary" level={5} lg={7}>
                                    <FormInput
                                      col
                                      md={24}
                                      name="authdetailamount"
                                    >
                                      <Text>
                                        {toCurrency(
                                          form.getFieldValue(
                                            'authdetailamount'
                                          ),
                                          tpAuth?.currcode ??
                                            localStorage.getItem('currcode') ??
                                            ''
                                        )}
                                      </Text>
                                    </FormInput>

                                    <FormInput col md={24} name="nominalrate">
                                      <Value
                                        formatter={(value) => toRate(value)}
                                      />
                                    </FormInput>
                                    <FormInput
                                      col
                                      md={24}
                                      name="authdetailavailableamount"
                                    >
                                      <Value
                                        formatter={(value) =>
                                          toCurrency(
                                            value,
                                            tpAuth?.currcode ??
                                              localStorage.getItem(
                                                'currcode'
                                              ) ??
                                              ''
                                          )
                                        }
                                      />
                                    </FormInput>
                                    <FormInput
                                      col
                                      md={24}
                                      name="authbookedamount"
                                    >
                                      <Value
                                        formatter={(value) =>
                                          toCurrency(
                                            value,
                                            tpAuth?.currcode ??
                                              localStorage.getItem(
                                                'currcode'
                                              ) ??
                                              ''
                                          )
                                        }
                                      />
                                    </FormInput>
                                    <FormInput
                                      col
                                      md={24}
                                      name="authdetailusedamount"
                                    >
                                      <Value
                                        formatter={(value) =>
                                          toCurrency(
                                            value,
                                            tpAuth?.currcode ??
                                              localStorage.getItem(
                                                'currcode'
                                              ) ??
                                              ''
                                          )
                                        }
                                      />
                                    </FormInput>
                                  </UtinaCard>
                                  <UtinaCard comcode="newUse" level={5} lg={7}>
                                    <Row gutter={8}>
                                      <FormInput
                                        col
                                        md={24}
                                        name="prcode"
                                        hidden
                                      >
                                        <Input hidden />
                                      </FormInput>

                                      <FormInput col md={24} name="offerlabel">
                                        <Value
                                          value={form.getFieldValue(
                                            'offerlabel'
                                          )}
                                        />
                                      </FormInput>

                                      <FormInput col md={24} name="amountToUse">
                                        <Value
                                          formatter={(value) =>
                                            toCurrency(
                                              value,
                                              tpAuth?.currcode ??
                                                localStorage.getItem(
                                                  'currcode'
                                                ) ??
                                                ''
                                            )
                                          }
                                        />
                                      </FormInput>

                                      <FormInput col md={24} name="endDate">
                                        <Value />
                                      </FormInput>
                                    </Row>
                                  </UtinaCard>
                                  <UtinaCard comcode="rate" level={5} lg={7}>
                                    <Row gutter={[8, 8]}>
                                      <FormInput
                                        col
                                        xs={24}
                                        name="calculationtype"
                                      >
                                        <ParListSelect
                                          parcode="CALMETHOD"
                                          disabled
                                        />
                                      </FormInput>
                                      {prefinmethod !== 'PREFINSTEP' ? (
                                        <>
                                          <FormInput
                                            col
                                            xs={24}
                                            name="ratetype"
                                            comcode="ratetype"
                                          >
                                            <ParListSelect
                                              parcode="RATETYPE"
                                              disabled
                                            />
                                          </FormInput>

                                          <FormInput
                                            col
                                            xs={24}
                                            name="rateref"
                                            comcode="rateref"
                                          >
                                            <Value
                                              formatter={() =>
                                                toRate(
                                                  form.getFieldValue('rateref')
                                                )
                                              }
                                            ></Value>
                                          </FormInput>
                                          <FormInput
                                            col
                                            xs={24}
                                            name="ratespread"
                                            comcode="ratespread"
                                          >
                                            <Value />
                                          </FormInput>
                                          <FormInput
                                            col
                                            xs={24}
                                            name="nominalrate"
                                            comcode="nominalrate"
                                          >
                                            <Value />
                                          </FormInput>
                                        </>
                                      ) : (
                                        <>
                                          <Form.Item shouldUpdate noStyle>
                                            {({ getFieldValue }) => {
                                              return (
                                                <FormInput
                                                  col
                                                  xs={24}
                                                  md={24}
                                                  name="ctepartmethod"
                                                  comcode="ctepartmethod"
                                                >
                                                  <ParListSelect
                                                    parcode="CTEPARTMET"
                                                    offerid={getFieldValue(
                                                      'offerid'
                                                    )}
                                                    disabled
                                                  />
                                                </FormInput>
                                              );
                                            }}
                                          </Form.Item>
                                          <Form.Item shouldUpdate noStyle>
                                            {({ getFieldValue }) => {
                                              return (
                                                <InputCurrency
                                                  col
                                                  md={24}
                                                  disabled
                                                  currcode={getFieldValue(
                                                    'currcode'
                                                  )}
                                                  comcode="ctepartamount"
                                                  fieldname="ctepartamount"
                                                />
                                              );
                                            }}
                                          </Form.Item>
                                        </>
                                      )}
                                    </Row>
                                  </UtinaCard>
                                </Row>
                              </Col>
                            </Row>
                          </TabPane>

                          {prefinmethod === 'PREFINSTEP' && (
                            <TabPane
                              tab={<GetLabel label="tabprefinsteps" />}
                              key={34}
                            >
                              <Card>
                                <Row justify="end">
                                  <Form.Item shouldUpdate noStyle>
                                    {({ getFieldValue }) => {
                                      return (
                                        <FinancialScheduleModal
                                          finElement={finElement}
                                          currcode={getFieldValue('currcode')}
                                          data={getFieldValue('elements')}
                                          comcode="globalSchedule"
                                          loading={loading}
                                          controller={
                                            <ScheduleButton
                                              size="large"
                                              comcode="globalSchedule"
                                              twoToneColor={
                                                isNil(getFieldValue('offerid'))
                                                  ? 'gray'
                                                  : 'green'
                                              }
                                              disabled={isNil(
                                                getFieldValue('offerid')
                                              )}
                                            ></ScheduleButton>
                                          }
                                        />
                                      );
                                    }}
                                  </Form.Item>
                                </Row>
                                <Form.Item shouldUpdate noStyle>
                                  {({ getFieldValue }) => {
                                    const _prefinStepsList =
                                      getFieldValue('_prefinStepsList');
                                    return (
                                      <>
                                        <Row justify="end">
                                          <ModalControllerNV
                                            content={({
                                              setVisible,
                                              visible,
                                            }) => (
                                              <ButtonOperation
                                                onClick={() => {
                                                  calculatePaymentShedulePrefinSteps(
                                                    finElement
                                                  );
                                                }}
                                                htmlType="button"
                                                comcode="calculate"
                                              />
                                            )}
                                            modal={({
                                              setVisible,
                                              visible,
                                            }) => (
                                              <ConElemPrefinStepModal
                                                visible={visible}
                                                onClose={() => {
                                                  setVisible(false);
                                                }}
                                                ctesorder={
                                                  1 +
                                                    _prefinStepsList?.length ??
                                                  0
                                                }
                                                onSave={(values, action) => {
                                                  const newConElemPrefinStepsList: any[] =
                                                    _prefinStepsList ?? [];
                                                  newConElemPrefinStepsList?.push();
                                                  form.setFieldValue(
                                                    '_prefinStepsList',
                                                    newConElemPrefinStepsList
                                                  );
                                                }}
                                                record={undefined}
                                              />
                                            )}
                                          ></ModalControllerNV>
                                        </Row>

                                        <DataGrid
                                          dataSource={_prefinStepsList ?? []}
                                          pagination={false}
                                          columns={columnsPrefinSteps}
                                          titleComcode="conElemPrefinSteps"
                                          rowKey={(e) => e.ctesid}
                                        />
                                      </>
                                    );
                                  }}
                                </Form.Item>
                              </Card>
                            </TabPane>
                          )}
                        </Tabs>
                      </div>
                    </UtinaCard>

                    <Row gutter={12}>
                      <Col span={12}>
                        <Button
                          className="btncard"
                          type="default"
                          htmlType="button"
                          comcode="cancel"
                          onClick={() => {
                            setRequestToSend(null);
                            setOffer(null);
                            form.resetFields();
                          }}
                          style={{
                            width: '100%',
                            height: '45px',
                            marginTop: '10px',
                            borderColor: 'red',
                          }}
                        />
                      </Col>
                      <Col span={12}>
                        <Popover
                          style={{ left: '499px', top: ' 219px' }}
                          content={content}
                          title={title}
                          trigger="click"
                          open={clicked}
                          onOpenChange={handleClickChange}
                        >
                          <Button
                            className="btncard"
                            type="primary"
                            htmlType="button"
                            // onClick={() => {
                            //   showDeleteConfirm();
                            // }}
                            loading={loading}
                            comcode="ok"
                            style={{
                              width: '100%',
                              height: '45px',
                              marginTop: '10px',
                            }}
                          />
                        </Popover>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <>
                    <Row justify="start">
                      <GetLabel
                        label="newcarfin3"
                        style={{ color: 'green', fontSize: 23 }}
                      />
                    </Row>
                    <UtinaCard comcode="req_accepet" level={4}>
                      <h2>
                        <span style={{ color: 'red', fontWeight: 'bold' }}>
                          {' '}
                          Note:{' '}
                        </span>{' '}
                        <GetLabel label="text3" />
                      </h2>
                      <Spin spinning={isFetching}>
                        <Row
                          style={{
                            fontSize: '16px',
                          }}
                        >
                          <Col span={8}>
                            {' '}
                            <GetLabel
                              label="authdetailamount"
                              style={{ fontWeight: 'bold', color: '#243882' }}
                            />{' '}
                          </Col>{' '}
                          <Col span={12} style={{ fontWeight: 600 }}>
                            {' '}
                            {toCurrency(tpAuthDetail?.authdetailamount)}
                          </Col>
                          <Col span={8}>
                            {' '}
                            <GetLabel
                              label="authdetailavailableamount"
                              style={{ fontWeight: 'bold', color: '#243882' }}
                            />{' '}
                          </Col>{' '}
                          <Col span={12} style={{ fontWeight: 600 }}>
                            {' '}
                            {toCurrency(
                              tpAuthDetail?.authdetailavailableamount
                            )}
                          </Col>
                          <Col span={8}>
                            {' '}
                            <GetLabel
                              label="aythdetailbookedamount"
                              style={{ fontWeight: 'bold', color: '#243882' }}
                            />
                          </Col>{' '}
                          <Col span={12} style={{ fontWeight: 600 }}>
                            {' '}
                            {toCurrency(tpAuthDetail?.authdetailbookedamount)}
                          </Col>
                          <Col span={8}>
                            {' '}
                            <GetLabel
                              label="authdetailusedamount"
                              style={{ fontWeight: 'bold', color: '#243882' }}
                            />{' '}
                          </Col>
                          <Col span={12} style={{ fontWeight: 600 }}>
                            {toCurrency(tpAuthDetail?.authdetailusedamount)}
                          </Col>
                        </Row>
                      </Spin>
                    </UtinaCard>
                  </>
                )}
              </Card>
            </Spin>
          </Col>
        </Row>

        <SimpleAssetModal
          flagreal={Boolean(form.getFieldValue('flagrealestate'))}
          onAdd={handleAddSimpleAsset}
          onCancel={simpleAssetModal.close}
          currcode={form.getFieldValue('currcode')}
          visible={simpleAssetModal.visible}
          assetclass="NC"
        />

        <Modal
          title={
            <GetLabel
              style={{ fontSize: 18, paddingLeft: 10 }}
              label="altertitle"
            />
          }
          centered
          open={open === 1}
          width={600}
          footer={null}
          closeIcon={
            <CloseOutlined
              onClick={() => {
                setOpen(2);
              }}
            />
          }
        >
          <div style={{ padding: 3 }}>
            <Badge.Ribbon text="Info" color="orange">
              <Card title=" " size="small">
                <Row justify="space-between">
                  <Col>
                    <GetLabel
                      style={{ fontSize: 18 }}
                      label="textvailableamount"
                    />
                  </Col>
                  <Col style={{ fontSize: 18 }}>
                    {' '}
                    <b>
                      {toCurrency(tpAuthDetail?.authdetailavailableamount ?? 0)}
                    </b>
                  </Col>
                </Row>
              </Card>
            </Badge.Ribbon>
          </div>
        </Modal>
      </Form>
    </DF.Provider>
  );
};

type UseOfferListParams = {
  catalogid?: number;
  duration?: number;
  filtersList?: prFilteringCriteria;
  filters?: string;
  finamount?: number;
  prcode?: string;
  searchMode: string; // PRCODE : by prcode, CATALOG : bu Catalog, FIN : by FinaMount and Duration
};

export default NewCarFin;
